import { Link } from '@inertiajs/react'

import { Button } from '@/components/ui/button'
import { newUserSessionPath } from '@/lib/routes'

export function UnloggedNavbar() {
  return (
    <Link href={newUserSessionPath()}>
      <Button size="sm">Sign in</Button>
    </Link>
  )
}
